import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@material-ui/core";

import * as actions from "../../store/actions/actionIndex";
// uitility function
import { decryptPhoneNumber, maskedNumber } from "../../helpers/utility";

const columns = [
	{ id: "campaign_name", label: "Campaign", minWidth: 100 },
	{ id: "cust_ph_no", label: "Customer Phone", minWidth: 100, align: "right" },
	{ id: "q_enter_time", label: "Queue Enter Time", minWidth: 120, align: "right" },
	{ id: "totalTime", label: "Duration(secs)", minWidth: 50, align: "right" },
	{ id: "skill", label: "Skill", minWidth: 100, align: "right" },
];

const useStyles = makeStyles({
	root: {
		width: "100%",
	},
	container: {
		maxHeight: 440,
	},
	closeButton :
	{
		float: "right",
		border: "1px solid #137dcc",
		borderRadius: 50,
		width: 25,
		marginInlineEnd: -12,
		marginTop: -4,
		cursor:"pointer"
	}
});

function CallInQueue(props) {
	
	const { agentId, onQueueCalls } = props;
	useEffect(() => {
		const getCallData = setInterval(() => {
			onQueueCalls(agentId);
		}, 10000);
		return () => {
			clearInterval(getCallData);
		};
	}, [agentId, onQueueCalls]);

	const classes = useStyles();
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);

	const rows = Array.from(props.queueCallData);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	return (
		<Paper className={classes.root}>
			<TableContainer className={classes.container}>
				<Table stickyHeader aria-label="sticky table" size="small">
					<TableHead>
						<TableRow style={{ height: "20px" }}>
							<TableCell key={0} align="center" colSpan={5}>
								Queue Details
								<span onClick={() => props.showQueueDetails(false)} className={classes.closeButton}>X</span>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableHead>
						<TableRow style={{ height: "20px" }}>
							{columns.map((column) => (
								<TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
									{column.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
							return (
								<TableRow hover role="checkbox" tabIndex={-1} key={row.code} style={{ height: "20px" }}>
									{columns.map((column) => {
										const value = row[column.id];
										return (
											<TableCell key={column.id} align={column.align}>
												{props.facilityConf.enable_number_mask ? (props.facilityConf.enable_number_mask === "1" && column.id === "cust_ph_no" ? maskedNumber(value, props.facilityConf.mask_start_pos, props.facilityConf.mask_end_pos) : column.format && typeof value === "number" ? column.format(decryptPhoneNumber(value)) : decryptPhoneNumber(value) ) : decryptPhoneNumber(value)}
											</TableCell>
										);
									})}
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination rowsPerPageOptions={[10, 25, 100]} component="div" count={rows.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
		</Paper>
	);
}

const mapStateToProps = (state) => {
	return {
		loading: state.queueCalls.loading,
		error: state.queueCalls.error,
		agentId: state.agentData.agentId,
		queueCallData: state.queueCalls.queueCallData,
		facilityConf: state.agentConfig.facilityConf,
	};
	
};

const mapDispatchToProps = (dispatch) => {
	return {
		onQueueCalls: (agentId) => dispatch(actions.queueCalls(agentId)),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(CallInQueue);